import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
    IconButton, Menu, MenuItem
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { Brush as StyleIcon } from '@material-ui/icons';

const S3 = 'https://landhawk.s3.eu-west-1.amazonaws.com'; // Should be switched to env or url on image


import { compose } from 'redux';
import { connect } from 'react-redux';
import { setCurrentStyle } from '../../../../redux/layer_settings/Actions';

class LayerStyles extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        layer: PropTypes.object.isRequired,
        // Redux State
        currentStyleIdx: PropTypes.number.isRequired,
        // Redux Dispatch
        dispatchSetCurrentStyle: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            styleAnchorEl: null
        };
        this.handleStyleMenuOpen = this.handleStyleMenuOpen.bind(this);
        this.handleStyleMenuClose = this.handleStyleMenuClose.bind(this);
        this.handleStyleMenuItemClick = this.handleStyleMenuItemClick.bind(this);
    }

    toggleFilters () {
        this.setState({
            styleAnchorEl: null
        });
    }

    handleStyleMenuOpen (event) {
        this.setState({ styleAnchorEl: event.currentTarget });
    }

    handleStyleMenuClose (event) {
        this.setState({ styleAnchorEl: null });
    }

    handleStyleMenuItemClick (event) {
        const { layer, dispatchSetCurrentStyle } = this.props;
        dispatchSetCurrentStyle(layer.system_name, event.target.value);
        this.handleStyleMenuClose(event);
    }

    render () {
        const { classes, layer, currentStyleIdx } = this.props;
        const { styleAnchorEl } = this.state;

        if (!(layer.styles && layer.styles.length > 1)) { return <></>; }

        return (
            <>
                <IconButton
                    className={classnames(classes.styleButton)}
                    onClick={this.handleStyleMenuOpen}
                >
                    <StyleIcon />
                </IconButton>
                <Menu
                    anchorEl={styleAnchorEl}
                    open={Boolean(styleAnchorEl)}
                    onClose={this.handleStyleMenuClose}
                >
                    {layer.styles.map((style, idx) =>
                        <MenuItem
                            key={idx}
                            selected={idx === currentStyleIdx}
                            value={idx}
                            onClick={this.handleStyleMenuItemClick}
                        >
                            {style.name}
                        </MenuItem>
                    )}
                </Menu>
            </>
        );
    }
}

const styles = theme => ({
    styleButton: {
        color: theme.palette.grey.variant3,
        padding: 0,
        marginRight: theme.constants.horizontalMargin
    }
});

const mapStateToProps = (state, ownProps) => {
    const layerSettings = state.layerSettingsReducer.find(settings => settings.uid === ownProps.layer.system_name);
    return {
        currentStyleIdx: (layerSettings && layerSettings.currentStyleIdx) || 0
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetCurrentStyle: (uid, idx) => dispatch(setCurrentStyle(uid, idx))
    };
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(LayerStyles);